import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as AuthReducer from '../reducers/authReducer';
import * as UserReducer from '../reducers/userReducer';
import OrganizationMembers from '../components/OrganizationMembers';
import { getCurrentOrg } from '../selectors/organizationSelectors';
import { getLoggedInUser, getActiveMemberIds, getInActiveMemberIds } from '../selectors/userSelectors';

class OrganizationMembersContainer extends Component {
  state = {
    panelOpen: !!this.props.match.params.memberId,
    usersLoading: true,
    memberFetchLoading: false,
    viewActive: true,
  };

  componentDidMount() {
    this.props.fetchMembers();
  }

  componentDidUpdate(prevProps) {
    const queryParamsChanged = prevProps.match.params.memberId !== this.props.match.params.memberId;

    if (queryParamsChanged) {
      this.setState({ panelOpen: !!this.props.match.params.memberId }); // eslint-disable-line react/no-did-update-set-state
    }

    if (this.props.usersLoading !== prevProps.usersLoading) {
      this.setState({ usersLoading: this.props.usersLoading }); // eslint-disable-line react/no-did-update-set-state
    }
  }

  handleLoadMore = () => {
    if (!this.state.memberFetchLoading) {
      this.setState({ memberFetchLoading: true }, () => {
        this.props.fetchMembers(this.props.pageNo + 1, this.state.viewActive)
          .then(() => {
            this.setState({ memberFetchLoading: false });
          });
      });
    }
  }

  handleCreateRequest = () => {
    this.props.history.push('/settings/organization/members/create');
  }

  handleToggleActive = () => {
    this.props.fetchMembers(0, !this.state.viewActive);
    this.setState((prevState) => ({ viewActive: !prevState.viewActive }));
    this.props.history.push('/settings/organization/members');
  }

  handleTogglePanel = (id) => {
    const shouldClose = this.state.panelOpen && (Number(this.props.match.params.memberId) === id || !id);

    if (shouldClose) {
      this.props.history.push('/settings/organization/members');
    } else {
      this.props.history.push(`/settings/organization/members/${id}`);
    }

    if (!id) {
      this.props.fetchMembers(this.props.pageNo, this.state.viewActive);
    }
  }

  render() {
    const props = {
      activeMember: this.props.users[this.props.match.params.memberId],
      activeMemberId: Number(this.props.match.params.memberId),
      activeMemberIds: this.props.activeMemberIds,
      viewActive: this.state.viewActive,
      handleCreateRequest: this.handleCreateRequest,
      handleToggleActive: this.handleToggleActive,
      handleTogglePanel: this.handleTogglePanel,
      inactiveMemberIds: this.props.inactiveMemberIds,
      panelOpen: this.state.panelOpen,
      users: this.props.users,
      totalUserCount: this.props.totalUserCount,
      usersLoading: this.state.usersLoading,
      memberFetchLoading: this.state.memberFetchLoading,
      isSSOEnabled: this.props.currentOrganization.isSSOEnabled,
      isCcr: this.props.currentUser.isCcr,
      handleLoadMore: this.handleLoadMore,
    };
    return <OrganizationMembers {...props} />;
  }
}

OrganizationMembersContainer.propTypes = {
  activeMemberIds: PropTypes.array.isRequired,
  currentUser: PropTypes.object,
  fetchMembers: PropTypes.func.isRequired,
  forgotPassword: PropTypes.func.isRequired,
  inactiveMemberIds: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  types: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
  users: PropTypes.object.isRequired,
  usersLoading: PropTypes.bool.isRequired,
  subscriptionLoading: PropTypes.bool.isRequired,
  pageNo: PropTypes.number,
  totalUserCount: PropTypes.number,
  history: PropTypes.object,
  currentOrganization: PropTypes.object,
};

const mapStateToProps = (state) => {
  const { type, user, billing } = state;
  return {
    activeMemberIds: getActiveMemberIds(state),
    currentUser: getLoggedInUser(state),
    currentOrganization: getCurrentOrg(state),
    inactiveMemberIds: getInActiveMemberIds(state),
    types: type.types,
    users: user.users,
    pageNo: user.memberPageNo,
    usersLoading: user.loading,
    subscriptionLoading: billing.subscriptionLoading,
    totalUserCount: user.totalMemberCount,
  };
};

const actions = {
  fetchMembers: UserReducer.fetchMembers,
  forgotPassword: AuthReducer.forgotPassword,
  updateUser: UserReducer.updateUser,
};

export default connect(mapStateToProps, actions)(OrganizationMembersContainer);
